import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Table } from 'reactstrap';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import '../../css/views/RecentActivities/recentActivities.css';
import AxiosInstance from '../../components/AxiosInstance/AxiosInstance';
import toast from '../../components/ErrorHandler/toast';

class RecentActivities extends Component {
    constructor(props) {
        super(props);
        this.state = {
          table_data: [],
          totalData: 10,
        };
      }

  componentDidMount(){

    AxiosInstance({
      method: "get",
      url: "tbBCM_t_AuditLog/usp_tbBCM_t_AuditLog_SelectTop10_V12",
    }).then(response => {
      
      this.setState({
        table_data: response.data
      });
    }).catch(error => {
    });
  }    
  
  render(){
    return (
      <Card className="right-col">
        <CardHeader>
          <h4 className="font-weight-semi-bold"> Recent Activities</h4>
          </CardHeader>
          <CardBody>
             <div>
                <Table className="card-rctAct">
                    <tbody>
                    {this.state.table_data.map((data, i) => {
                  if (i < this.state.totalData)
                    return (
                      <tr key={i}>
                        <td className="hide">{data.sort}</td>
                        <td dangerouslySetInnerHTML={{ __html: data.action + " at screen " + data.screenName + " on " + data.objectLang }} />
                      </tr>
                    )
                })}                    
                   </tbody>
                </Table>               
             </div>
          </CardBody>
       </Card>
    );
  }
}
export default RecentActivities;
